import { Plane, Ship, CalendarClock } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { SCHEDULE } from "@/lib/site-data";

const ICONS = [CalendarClock, Plane, Ship];

export default function Schedule() {
  return (
    <section className="relative py-20 sm:py-24">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <Reveal>
          <div className="grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:items-center">
            <div>
              <div className="mb-4 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.22em] text-[#E31B23]">
                <span className="h-px w-8 bg-[#E31B23]" /> Shipping schedule
              </div>
              <h2 className="font-display text-3xl font-extrabold leading-tight text-[#1F1F1F] sm:text-4xl">
                Four departures. Every single week.
              </h2>
              <p className="mt-4 max-w-md text-[#4b5563]">
                Never wait long for your package. We run three air cargo shipments and one ocean
                sailing to Jamaica weekly — so whether it's a small parcel or a full load, there's
                always a departure around the corner.
              </p>
            </div>

            <div className="grid gap-4 sm:grid-cols-3">
              {SCHEDULE.map((s, i) => {
                const Icon = ICONS[i];
                return (
                  <motion.div
                    key={s.label}
                    whileHover={{ y: -6 }}
                    transition={{ type: "spring", stiffness: 300, damping: 24 }}
                    data-testid={`schedule-${i}`}
                    className="card-soft rounded-3xl p-6"
                  >
                    <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#5A189A]/10">
                      <Icon size={18} className="text-[#5A189A]" />
                    </span>
                    <div className="mt-5 font-display text-4xl font-extrabold text-[#1F1F1F]">{s.value}</div>
                    <div className="mt-1 text-sm font-semibold text-[#1F1F1F]">{s.label}</div>
                    <p className="mt-2 text-xs leading-relaxed text-[#9ca3af]">{s.note}</p>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
